import { getElections } from '@api/getElections';
import { useEffect, useState } from 'react';

export type ElectionsType = {
  election_date: string;
  election_name_bn: string;
  election_name_en: string;
  election_schedule_id: number;
  election_type: number;
  is_active: boolean;
};

export interface useElectionsType {
  elections: ElectionsType[];
  isLoading: boolean;
}

export const useElections = (): useElectionsType => {
  const [elections, setElections] = useState<ElectionsType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    getElections()
      .then((data) => {
        setElections(data?.data?.elections || []);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }, []);

  return {
    elections,
    isLoading,
  };
};
